/**
 * Initialize blocks and set conditions according to the device
 *
 */
export function initToc(){
    [...document.querySelectorAll(".c-toc:not(.-initialiazed)")].forEach((item) => handleToc(item));
}

/**
 * Handle TOC
 * @param {HTMLElement} group - The TOC group element
 */
function handleToc(group){
    group.classList.add('-initialiazed');

    const tocLinks = document.querySelectorAll(".c-toc a");

    // Create Intersection Observer
    const observer = new IntersectionObserver((entries) => {

        entries.forEach(entry => {
            const targetId = entry.target.getAttribute('id');
            const correspondingLink = document.querySelector(`.c-toc a[href="#${targetId}"]`);

            correspondingLink.addEventListener('click', (e) => {
                e.preventDefault();
                const targetElement = document.getElementById(targetId);
                targetElement.scrollIntoView({ behavior: 'smooth' });

                setTimeout(() => {
                    history.replaceState(null, null, ' ');
                }, 0);
            });

            if (entry.isIntersecting) {
                // Remove '-active' class from all links
                tocLinks.forEach(link => link.classList.remove('-active'));
                correspondingLink.classList.add('-active');
            }
        });
    }, {
        rootMargin: '-100px 0px -50% 0px'
    });

    // Observe each TOC item
    tocLinks.forEach(link => {
        const targetId = link.getAttribute('href').slice(1); // Get the ID of the target element
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
            observer.observe(targetElement);
        }
    });

    tocLinks.forEach(function (link){
        link.addEventListener("click", function (e){
            const tocInner = link.closest('.c-toc__inner');
            const tocList = tocInner.querySelector('.c-toc__list');

            tocList.classList.remove('c-toc__list--open');
        });
    });
}

/**
 * Function to handle click event on TOC title to open when mobile
 * Call this function when a .c-toc__title titleNode is clicked
 *
 * @param {Event} event - The click event
 * @param {HTMLElement} titleNode - The titleNode that was clicked
 */
export function handleTocOpenClick(event, titleNode){

    // Find the corresponding c-toc__list
    const tocInner = titleNode.closest('.c-toc__inner');
    const tocList = tocInner.querySelector('.c-toc__list');

    // Toggle the class "-flipped" on the parent element
    tocList.classList.toggle('c-toc__list--open');
}
